import { motion } from 'framer-motion';

const PRESETS = {
  up:    { hidden: { opacity: 0, y: 36 },    visible: { opacity: 1, y: 0 } },
  down:  { hidden: { opacity: 0, y: -36 },   visible: { opacity: 1, y: 0 } },
  left:  { hidden: { opacity: 0, x: 44 },    visible: { opacity: 1, x: 0 } },
  right: { hidden: { opacity: 0, x: -44 },   visible: { opacity: 1, x: 0 } },
  scale: { hidden: { opacity: 0, scale: 0.93 }, visible: { opacity: 1, scale: 1 } },
  fade:  { hidden: { opacity: 0 },            visible: { opacity: 1 } },
};

const EASE = [0.25, 0.46, 0.45, 0.94];

export default function Reveal({
  children,
  variant = 'up',
  delay = 0,
  duration = 0.6,
  className,
  style,
}) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-55px' }}
      variants={{
        hidden: PRESETS[variant].hidden,
        visible: {
          ...PRESETS[variant].visible,
          transition: { duration, delay, ease: EASE },
        },
      }}
      className={className}
      style={style}
    >
      {children}
    </motion.div>
  );
}

/* Stagger container — wraps a list of RevealItem children */
export function RevealList({ children, stagger = 0.1, className, style }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: '-55px' }}
      variants={{
        hidden: {},
        visible: { transition: { staggerChildren: stagger } },
      }}
      className={className}
      style={style}
    >
      {children}
    </motion.div>
  );
}

/* Individual item inside RevealList */
export function RevealItem({ children, variant = 'up', className, style }) {
  return (
    <motion.div
      variants={{
        hidden: PRESETS[variant].hidden,
        visible: {
          ...PRESETS[variant].visible,
          transition: { duration: 0.55, ease: EASE },
        },
      }}
      className={className}
      style={style}
    >
      {children}
    </motion.div>
  );
}
